import { IVin } from 'types/carrier'
import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { ENDPOINTS } from 'utils/api/callApi'
import { keymirror } from 'utils/keymirror'

export const VINS_ACTION_TYPES = generateApiActionTypes('VINS')
export const VINS_SAVE_ACTION_TYPES = generateApiActionTypes('VINS_SAVE')
export const VINS_DIALOG_ACTION_TYPES = keymirror({
  OPEN_VINS_DIALOG: undefined,
  CLOSE_VINS_DIALOG: undefined,
})

export const VINS_EDIT_ACTION_TYPES = keymirror({
  ADD_VIN: undefined,
  DELETE_VIN: undefined,
})

export const getCarrierVins = (id: string) => {
  const requestData = {
    endpoint: ENDPOINTS.carriers,
    id,
    group: 'scheduled_vins',
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(VINS_ACTION_TYPES),
    },
  }
}

export const addCarrierVin = (vin: string) => ({
  type: VINS_EDIT_ACTION_TYPES.ADD_VIN,
  vin,
})

export const deleteCarrierVin = (vin: IVin) => ({
  type: VINS_EDIT_ACTION_TYPES.DELETE_VIN,
  vin,
})

export const saveCarrierVins = (id: string, scheduledVins: IVin[]) => {
  const requestData = {
    endpoint: ENDPOINTS.carriers,
    method: 'POST',
    id,
    group: 'scheduled_vins',
    body: { scheduledVins },
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(VINS_SAVE_ACTION_TYPES),
    },
  }
}

export const showVinsDialog = () => ({
  type: VINS_DIALOG_ACTION_TYPES.OPEN_VINS_DIALOG,
})

export const closeVinsDialog = () => ({
  type: VINS_DIALOG_ACTION_TYPES.CLOSE_VINS_DIALOG,
})
